jQuery(document).ready(function($) {

    // Initialize Foundation 
    $(document).foundation();

    // Smooth scroll on click of anchor links
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 500);
    });    

    // Video Popup Events
    // $('.play-button').click(function() {
    //     var $data = $(this).data('open');
    //     var $activeVideo = $('#' + $data).find('video');
    //     var $activeVideoClose = $('#' + $data).find('.close-button');
    //     $($activeVideo).addClass('active').get(0).play();

    //     // Pause & restart video on click of X(close)
    //     $($activeVideoClose).click(function() {
    //         $activeVideo.get(0).pause();
    //         $activeVideo[0].currentTime = 0;
    //     });

    //     // Pause & restart video on ESC button click
    //     $(document).keyup(function(e) {
    //         if (e.keyCode == 27) {
    //             $activeVideo.get(0).pause();
    //             $activeVideo[0].currentTime = 0;
    //         }
    //     });        
    // });     
 
    // Exit form and close reveal
    // $(document).on('click', '.exit-form', function(e) {
    //     $('.reveal').foundation('close');
    // });
    
    // Prevent Gravity Forms form being submitted twice
    var gformSubmitted = false;
    $(".gform_wrapper form").submit(function(event) {
        if (gformSubmitted) {
            event.preventDefault();
        }
        else {
            gformSubmitted = true;
            $("button[type='submit']", this).html("<i class='fas fa-spinner fa-spin'></i>").attr("disabled", true);
        }
    });

    // Mobile tabs to dropdown
    // $('.responsive-tabs a').click(function(e) {
    //     if ($(this).hasClass('active')) {
    //         e.preventDefault();
    //         $('.responsive-tabs ul').toggleClass('opened');
    //     } else {
    //         $('.responsive-tabs ul').toggleClass('opened');
    //     }
    // });   
    

    // Calculate top positioning of off-canvas mobile navigation 
    $(window).on('load resize', function() {
        $('#mobile-nav').css('top', $('#site-navigation').outerHeight() + 'px');
    }); 

    // Mobile Nav - Disable Body Scrolling
    $(window).load(function() {
        $('.hamburger').click(function() {
            $('.hamburger').toggleClass('active');
            if ($('.hamburger').hasClass('active')) {
                $('#main-menu, #site-navigation').addClass('active');
                $('body').css("overflow", "hidden");
            } else {
                $('#main-menu, #site-navigation').removeClass('active');
                $('body').css("overflow", "auto");
            }
        });
    });

    // Close mobile menu on link click
    $('.off-canvas .anchor-link').on('click', function() {
        $('.off-canvas').foundation('close');
        $('body').css("overflow", "auto");
        $('.hamburger').toggleClass('active');
    });

    $('.headline').addClass('fade-in');
    $('.subheadline').addClass('fade-in');    

    // Services Scroll

    // Scroll Item timeline
    // $(".scroll-item").each(function(i) {
    //     var $this = $(this),
    //         tl = gsap.timeline();
        
    //     $(window).on('load', function() {
    //         if ($(window).width() < 768) {
    //             tl.from($this,{duration: 0.7, opacity:0, y:100});
    //         }
    //     });
        
    //     new ScrollMagic.Scene({
    //         triggerElement: this,
    //         triggerHook: 0.8
    //     })
    //         .reverse(false)
    //         .setTween(tl)
    //         .addTo(controller);
    // });
    
    if ($(".scroll-wrapper")[0]){

        var $scrollWrap = $('.scroll-wrapper'),
            $scrollBgImage = $('.scroll-bg-image'),
            $scrollItem = $('.scroll-item'),
            $scrollCopy = $('.scroll-copy'),
            $indicatorWrap = $('.scroll-indicators'),
            $indicatorWrapHeight = $indicatorWrap.height(),
            $indicator = $('.scroll-indicators li'),
            $lastIndictor = $('.scroll-indicators li:last-child'),
            $lastScrollItem = $('.scroll-item:last-child'),
            $lastScrollItemHeight = $lastScrollItem.outerHeight(),
            $topOffset = 225,
            $offsetHalf = $(window).height() / 5;

        $('.indicator').click(function() {
            var $count = $(this).data('indicator-count');
            $('html, body').animate({
                scrollTop: $('#scroll-item-' + $count).offset().top - $offsetHalf
            }, 500);
        });

        $(window).on('resize scroll', function() {
            if ($(window).width() >= 768) {

                // Add fixed positioning to indicators
                var $winScroll = $(window).scrollTop(),
                    $stickyTop = $scrollWrap.offset().top - $topOffset;

                if ($winScroll >= $stickyTop) {
                    $scrollWrap.addClass('fixed');
                    $scrollBgImage.addClass('fixed');
                    $indicatorWrap.css('top', $topOffset);
                } else {
                    $scrollWrap.removeClass('fixed');
                    $scrollBgImage.removeClass('fixed');
                    $indicatorWrap.css('top', '');
                }

                // Pin indicators when reaching last scroll item
                if ($lastIndictor.is('.active')){
                    $scrollWrap.removeClass('fixed').addClass('pinned');
                    $scrollBgImage.removeClass('fixed').addClass('pinned');
                    $indicatorWrap.css({'bottom': $lastScrollItemHeight - $indicatorWrapHeight, 'top': 'auto'});
                } else {
                    $scrollWrap.removeClass('pinned');
                    $scrollBgImage.removeClass('pinned');
                    $indicatorWrap.css('bottom', '');
                }

                // Add active class to indicator when scroll item is in view
                $($scrollItem).each(function() {
                    var activeCount = $(this).data('scroll-count').toString(),
                        percent = (100 / ((jQuery(this).offset().top + $topOffset) - jQuery(window).scrollTop()));
                    if (percent < 0.2) {
                        jQuery(this).find($scrollCopy).css('opacity', (percent * 3));
                    } else {
                        jQuery(this).find($scrollCopy).css('opacity', ((1-percent) * 5));
                    }                        
                    if ($(this).offset().top - $winScroll < $topOffset) {
                        $scrollItem.removeClass('active');
                        $indicator.removeClass('active');
                        $('#indicator' + activeCount).addClass('active');
                        $('#scroll-item-' + activeCount).addClass('active');
                    }
                }); 
            }
        });
    }    


    // Timeline Horizontal Slider
    // var controller = new ScrollMagic.Controller,
    //     controller2 = new window.ScrollMagic.Controller({
    //         vertical: false,
    //         refreshInterval: 1
    //     }),
    //     controller3 = new window.ScrollMagic.Controller({
    //         vertical: false,
    //         refreshInterval: 1
    //     }),
    //     windowWidth = window.outerWidth,
    //     slideCount = $("#timeline-scroll-wrapper .section").length,
    //     slideWidth = $("#timeline-scroll-wrapper .section").outerWidth(),
    //     slideExtraSpace = (slideCount + 1) * 120,
    //     slideContainerWidth = slideWidth*slideCount-windowWidth + slideExtraSpace,
    //     actionHorizontal = gsap.timeline().to("#timeline-scroll-wrapper .slideContainer", 1, {x: -slideContainerWidth}),
    //     horizontal = createHorizontal();

    // function createHorizontal() {
    //     return new ScrollMagic.Scene({
    //         triggerElement: "#timeline-scroll-wrapper",
    //         triggerHook: "onLeave",
    //         duration: slideContainerWidth
    //     })
    //     .setPin("#timeline-scroll-wrapper")
    //     .setTween(actionHorizontal)
    //     .addTo(controller);
    // }   

    // $("#timeline-scroll-wrapper .section").each(function(i) {
    //     var imageLarge = $(this).find(".scroll-stacked-images img.large")
    //     var imageSmall = $(this).find(".scroll-stacked-images img.small")
    //     var tl = gsap.timeline()
    //     tl
    //     .fromTo(imageLarge, {y: -20}, { y: 0, duration: 2, ease: Power0.easeOut }, 0)
    //     .fromTo(imageSmall, {x: 100}, {  x: 0, duration: 2, ease: Power0.easeOut }, 0)
    // new window.ScrollMagic.Scene({
    //     triggerElement: this,
    //     triggerHook: "onEnter",
    //     duration: '100%',
    //     tweenChanges: true
    // })
    // .setTween(tl)
    // .addTo(controller2)
    // });

    // 	// build scenes
    //     new ScrollMagic.Scene({triggerElement: ".change-to-white"})
    //         .setClassToggle("#timeline-scroll-wrapper", "white") // add class toggle
    //         .addTo(controller3);
         
    // $(window).resize(function(){
    //     windowWidth = window.outerWidth;
    //     slideContainerWidth = slideWidth*slideCount-windowWidth + slideExtraSpace;
    //     horizontal.destroy(true);
    //     horizontal = createHorizontal();
    // });   

});